import axiosClient from "./axiosClient";

// Kênh cộng đồng — API quản trị (admin + mod có quyền 'community').
// Đăng/sửa/xoá bài deal (plain text + tối đa 6 ảnh), ghim bài, quản lý danh mục.
const communityApi = {
    // --- Bài đăng ---
    // filters: { q, category, owner, from, to, pinned, visibility } — ô trống bị bỏ qua
    getAdminPosts(page = 1, limit = 20, filters = {}) {
        const params = { page, limit };
        Object.entries(filters).forEach(([k, v]) => {
            if (v !== undefined && v !== null && v !== "") params[k] = v;
        });
        return axiosClient.get("community/admin_posts", { params });
    },
    // Mọi tác giả có bài đang hiện — đổ vào ô lọc "Tác giả"
    getAdminPostAuthors() {
        return axiosClient.get("community/admin_post_authors");
    },
    createPost(formData) {
        return axiosClient.post("community/new_post", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    updatePost(formData) {
        return axiosClient.post("community/update_post", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    deletePost(postId) {
        return axiosClient.post("community/delete_post", { postId });
    },
    setPinned(postId, pinned) {
        return axiosClient.post("community/pin", { postId, pinned });
    },

    // --- Duyệt bài user đăng ---
    getPendingPosts(page = 1, limit = 20) {
        return axiosClient.get(`community/pending_posts?page=${page}&limit=${limit}`);
    },
    // action: 'approve' | 'reject'; reason bắt buộc khi action = 'reject'
    moderatePost(postId, action, reason) {
        return axiosClient.post("community/moderate_post", { postId, action, reason });
    },

    // --- Cấu hình số bài/giờ user (CTV) được đăng ---
    getPostLimit() {
        return axiosClient.get("community/post_limit");
    },
    updatePostLimit(limit) {
        return axiosClient.put("community/post_limit", { limit });
    },

    // --- Tự ẩn bài khỏi feed sau N ngày (0 = tắt, bài ghim không bị ẩn) ---
    getHideDays() {
        return axiosClient.get("community/hide_days");
    },
    updateHideDays(days) {
        return axiosClient.put("community/hide_days", { days });
    },

    // --- API key cho hệ thống ngoài: bot đăng bài + site tiện ích (chỉ admin) ---
    getApiKeys() {
        return axiosClient.get("community/api_keys");
    },
    /**
     * Trả về { key } — chuỗi GỐC chỉ hiện đúng lần này, không xem lại được.
     * @param scope 'community' (bot đăng bài) | 'utility-notify' (site tiện ích gửi noti)
     * @param site  slug tiện ích, bắt buộc khi scope = 'utility-notify'
     */
    createApiKey(name, userId, scope, site) {
        return axiosClient.post("community/api_keys", { name, userId, scope, site });
    },
    revokeApiKey(id) {
        return axiosClient.post("community/api_keys/revoke", { id });
    },
    /** Xoá HẲN dòng key (thu hồi chỉ đánh dấu) — mất luôn lịch sử dùng. */
    deleteApiKey(id) {
        return axiosClient.post("community/api_keys/delete", { id });
    },

    // --- Bot Telegram tự đăng bài (chỉ admin) ---
    getTelegramConfig() {
        return axiosClient.get("community/telegram_config");
    },
    updateTelegramConfig(config) {
        return axiosClient.put("community/telegram_config", { config });
    },

    // --- Danh mục ---
    getCategories() {
        return axiosClient.get("community/categories");
    },
    // categories: mảng { name, icon } (icon = filename hoặc null)
    updateCategories(categories) {
        return axiosClient.put("community/categories", { categories });
    },
    // Upload icon danh mục (1 file, field 'image') -> { filename }
    uploadCategoryIcon(file) {
        const formData = new FormData();
        formData.append("image", file);
        return axiosClient.post("community/category_icon", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
};

export default communityApi;
